<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="600">
    <template v-slot:title>Copy Service</template>
    <v-row>
      <v-col class="pb-0"
        ><v-text-field
          v-model="newName"
          label="New Name"
          :outlined="outlinedInputs"
        ></v-text-field
      ></v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-container class="py-0">
          <v-row align="baseline">
            <v-col class="py-0">
              <v-switch v-model="servicePrices" label="Rates"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch v-model="serviceTaxes" label="Taxes"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch v-model="serviceExtras" label="Extras"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch v-model="serviceContent" label="Contents"></v-switch>
            </v-col>
            <v-col class="py-0">
              <v-switch
                v-model="allocations"
                label="Allocations/Closeouts"
              ></v-switch>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onSave">Copy</v-btn>
    </template>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "../../shared/BasicDialog";
const CLONE_SERVICE = gql`
  mutation cloneService($input: CloneServiceInput!) {
    cloneService(input: $input) {
      id
      name
    }
  }
`;
export default {
  name: "clone-service",

  props: {
    show: {
      type: Boolean,
      default: () => true,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
  },

  data() {
    return {
      newName: this.value ? `${this.value.name} Copy` : "New Name",
      serviceExtras: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      serviceContent: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      servicePrices: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      serviceTaxes: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
      allocations: !this.$store.getters.hasAccessTo(
        "suppliers:copy_options_off"
      ),
    };
  },

  computed: {
    isValid() {
      return this.newName != "" && this.value && this.value.id != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newVal) {
      this.newName = `${newVal.name} Copy`;
    },
  },

  methods: {
    onSave() {
      const input = {
        id: this.value.id,
        newName: this.newName,
        allocations: this.allocations,
        serviceExtras: this.serviceExtras,
        serviceContent: this.serviceContent,
        servicePrices: this.servicePrices,
        serviceTaxes: this.serviceTaxes,
      };
      this.cloneService(input);
    },
    async cloneService(input) {
      try {
        const result = await this.$apollo.mutate({
          mutation: CLONE_SERVICE,
          variables: { input },
        });
        //console.log(result);
        if (result.data.cloneService.id) {
          this.$emit("complete", { ...result.data.cloneService });
        }
      } catch (error) {
        console.log(error);
        const errorMsg = error.graphQLErrors.map((e) => e.message).join(", ");
        this.$store.dispatch("showAppSnackbar", {
          msg: errorMsg,
          color: "error",
        });
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/services/CloneService.vue